import axiosInstance from '@/utils/api.js'

var state = {
  blockings: []
}

var getters = {
  BLOCKINGS: (state) => {
    return state.blockings
  }
}

var mutations = {
  SET_BLOCKINGS: (state, payload) => {
    state.blockings = payload
  }
}

var actions = {
  GET_BLOCKINGS: async (context, payload) => {
    let result = await axiosInstance.get('/reports/blocks?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&account_id=0' + '&group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&limit=' + payload.limit +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_BLOCKINGS', result.data)
    }
  },
  CLEAR_BLOCKING: (context) => {
    context.commit('SET_BLOCKINGS', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/blockings.js